import React, {useEffect, useRef, useState} from 'react';
import "./AddEmployeeForm.css";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import axios from "axios";
import {Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import LoaderCustom from "../../../components/ConfirmationModal/LoaderCustom";
import {FaEye} from "react-icons/fa";

const AddEuroDocumentForm = () => {
    const fileInputRef = useRef(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [documents, setDocuments] = useState([]);
    const [alertType, setAlertType] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [fileName, setFileName] = useState('');
    const [fileURL, setFileURL] = useState('');
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const [currentDocId, setCurrentDocId] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editDocId, setEditDocId] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        nameEng: '',
        file: {
            base64String: '',
            ext: ''
        }
    });
    const openConfirmModal = (docId) => {
        setCurrentDocId(docId);
        setConfirmModalOpen(true);
    };

    const closeConfirmModal = () => {
        setConfirmModalOpen(false);
    };

    const confirmDelete = async () => {
        if (currentDocId) {
            await handleDeleteDocument(currentDocId);
        }
        closeConfirmModal();
    };


    const handleDeleteDocument = async (docId) => {
        const jwtToken = localStorage.getItem('jwtToken');
        if (!jwtToken) {
            setAlertMessage('JWT Token is missing');
            setAlertType('error');
            setShowAlert(true);
            return;
        }
        setIsLoading(true)
        try {
            const response = await axios({
                method: 'PUT',
                url: `${process.env.REACT_APP_API_BASE_URL}/DeleteEuroDocumentFile`,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${jwtToken}`
                },
                data: {
                    id: docId
                }
            });

            if (response.data.success) {
                setAlertMessage('ოპერაცია წარმატებით დასრულდა');
                setAlertType('success');
                fetchDocuments(); // Refresh the document list
            } else {
                setAlertMessage('Failed to delete document');
                setAlertType('error');
            }
        } catch (error) {
            console.error('Error deleting document:', error);
            setAlertMessage('Error deleting document');
            setAlertType('error');
        }
        setShowAlert(true);
        setIsLoading(false)
    };

    const fetchDocuments = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllEuroDocumentFile`);
            if (response.data.success && response.data.data) {
                setDocuments(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching documents:', error);
        }
        setIsLoading(false)
    };

    useEffect(() => {
        fetchDocuments();
    }, []);
    const resetForm = () => {
        setFormData({
            name: '',
            nameEng: '',
            file: {
                base64String: '',
                ext: ''
            }
        });
        setFileName('');
        setFileURL('');
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };
    const handleEditDocument = (doc) => {
        setIsEditMode(true);
        setEditDocId(doc.id);
        setFormData({
            name: doc.name,
            nameEng: doc.nameEng,
            file: {
                base64String: '', // Assuming you don't load the file content for editing
                ext: 'pdf' // Assuming the file is always a PDF
            }
        });
    };

    const handleInputChange = (e) => {
        if (e.target.name === 'file') {
            handleFileChange(e);
        } else {
            setFormData({...formData, [e.target.name]: e.target.value});
        }
    };

    const isFormComplete = () => {
        return formData.name.trim() !== '' &&
            formData.nameEng.trim() !== '' &&
            formData.file.base64String !== '';
    };

    const handleFileChange = (e) => {
        e.persist();
        const file = e.target.files[0];
        if (file && file.type === "application/pdf") {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFormData({
                    ...formData,
                    file: {
                        base64String: reader.result.split(',')[1], // Remove the data URL part
                        ext: 'pdf'
                    }
                });
            };
            reader.readAsDataURL(file);
            setFileName(file.name);
            setFileURL(URL.createObjectURL(file));
        } else {
            alert('არაწორი ფორმატი, მხოლოდ PDF');
        }
    };

    const handleDeleteFile = () => {
        setFileName('');
        setFileURL('');
        setFormData({...formData, file: {base64String: '', ext: ''}});
        if (fileInputRef.current) {
            fileInputRef.current.value = ''; // Reset the file input
        }
    };

    const handleCancelEdit = () => {
        setIsEditMode(false);
        setEditDocId(null);
        resetForm();
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setIsModalOpen(true);
    };

    const handleConfirm = async () => {
        setIsModalOpen(false);
        const jwtToken = localStorage.getItem('jwtToken');
        if (!jwtToken) {
            setAlertMessage('JWT Token is missing');
            setAlertType('error');
            setShowAlert(true);
            return;
        }
        setIsLoading(true);

        const url = isEditMode ?
            `${process.env.REACT_APP_API_BASE_URL}/EditEuroDocumentFile` :
            `${process.env.REACT_APP_API_BASE_URL}/AddNewEuroDocumentFile`;

        try {
            const response = await axios({
                method: isEditMode ? 'PUT' : 'POST',
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${jwtToken}`
                },
                data: isEditMode ? {...formData, id: editDocId} : formData
            });

            if (response.data.success) {
                resetForm();
                setAlertMessage(isEditMode ? 'დოკუმენტი განახლდა' : 'დოკუმენტი დაემატა წარმატებით');
                setAlertType('success');
                await fetchDocuments();
                setIsEditMode(false); // Exit edit mode
                setEditDocId(null);
            } else {
                setAlertMessage('დაფიქსირდა შეცდომა, ცადეთ მოგივანებით');
                setAlertType('error');
            }
        } catch (error) {
            setAlertMessage('Error submitting form');
            setAlertType('error');
        }
        setShowAlert(true);
        setIsLoading(false);
    };

    return (
        <div>
            {isLoading ? (<LoaderCustom/>) : (

                <div className="employee-form-wrapper">
                    <h1 className="employee-form-title">ევროინტეგრაცია</h1>
                    <form onSubmit={handleSubmit} className="employee-form">
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            placeholder="დოკუმენტის სახელი"
                            className="employee-input"
                        />
                        <input
                            type="text"
                            name="nameEng"
                            value={formData.nameEng}
                            onChange={handleInputChange}
                            placeholder="დოკუმენტის სახელი (ინგლისურად)"
                            className="employee-input"
                        />
                        <label htmlFor="file-upload" className="custom-file-upload">
                            {fileName || 'დოკუმენტის ატვირთვა (PDF)'}
                        </label>
                        {fileName && (
                            <div className={"euro-button-container"}>
                                <a href={fileURL} target="_blank" rel="noopener noreferrer"
                                   className="file-preview-link-eu">
                                    დოკუმენტის ნახვა
                                </a>
                                <button onClick={handleDeleteFile} className="delete-image-button-eu">
                                    დოკუმენტის წაშლა
                                </button>
                            </div>
                        )}
                        <input
                            ref={fileInputRef}
                            id="file-upload"
                            type="file"
                            name="file"
                            onChange={handleInputChange}
                            accept=".pdf"
                            className="employee-file-input"
                        />
                        <button type="submit" className="employee-submit-button" disabled={!isFormComplete()}>
                            {isEditMode ? "რედაქტირება" : "დამატება"}
                        </button>

                    </form>

                    {isEditMode && (
                        <button type="submit" className="employee-cancel-submit-button" onClick={handleCancelEdit}>
                            რედაქტირების გაუქმება
                        </button>
                    )}
                    <TableContainer style={{marginTop: 25}} component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>დოკუმენტის სახელი</TableCell>
                                    <TableCell>დოკუმენტის სახელი ინგლისურად</TableCell>
                                    <TableCell>ნახვა</TableCell>
                                    <TableCell>ქმედება</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {documents.map((doc) => (
                                    <TableRow key={doc.id}>
                                        <TableCell>{doc.name}</TableCell>
                                        <TableCell>{doc.nameEng}</TableCell>
                                        <TableCell>
                                            <a href={doc.path} target="_blank" rel="noopener noreferrer">
                                                <FaEye className={"uncle-sam-eye"}/>
                                            </a>
                                        </TableCell>
                                        <TableCell>

                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() => handleEditDocument(doc)}
                                                style={{width: 100, marginRight: 10}}
                                            >
                                                რედაქტირება
                                            </Button>
                                            <Button variant="contained"
                                                    color="error"
                                                    onClick={() => openConfirmModal(doc.id)}
                                                    style={{width: 100}}
                                            >
                                                წაშლა
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <ConfirmationModal
                        isOpen={isModalOpen}
                        onRequestClose={() => setIsModalOpen(false)}
                        onConfirm={handleConfirm}
                    />
                    <ConfirmationModal
                        isOpen={confirmModalOpen}
                        onRequestClose={closeConfirmModal}
                        onConfirm={confirmDelete}
                    />
                    {showAlert && (
                        <CustomAlert
                            message={alertMessage}
                            type={alertType}
                            onClose={() => setShowAlert(false)}
                        />
                    )}
                </div>
            )
            }


        </div>

    );
};

export default AddEuroDocumentForm;
